export default __webpack_public_path__ + "static/media/pencil.f98a0a96.svg";